import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

function useProductsData(): Array<MobileNavCardProps> {
    return useMemo(() => {
        return [
            {
                key: "jira",
                logo: "jira",
                href: "/software/jira",
                name: "Jira",
                description: defineMessage({
                    id: "globalnav.v2.products.jira.description",
                    defaultMessage: "Flexible project management"
                }),
                isNew: false
            },
            {
                key: "confluence",
                logo: "confluence",
                href: "/software/confluence",
                name: "Confluence",
                description: defineMessage({
                    id: "globalnav.v2.products.confluence.description",
                    defaultMessage: "Knowledge, all in one place"
                }),
                isNew: false
            },
            {
                key: "jsm",
                logo: "jiraservicemanagement",
                href: "/software/jira/service-management",
                name: "Jira Service Management",
                description: defineMessage({
                    id: "globalnav.v2.products.jsm.description",
                    defaultMessage: "High-velocity service delivery"
                }),
                isNew: false
            },
            {
                key: "trello",
                logo: "trello",
                href: "//trello.com/home",
                name: "Trello",
                description: defineMessage({
                    id: "globalnav.v2.products.trello.description",
                    defaultMessage: "Organized & visualized work"
                }),
                isNew: false
            },
            {
                key: "jpd",
                logo: "jiraproductdiscovery",
                href: "/software/jira/product-discovery",
                name: "Jira Product Discovery",
                description: defineMessage({
                    id: "globalnav.v2.products.jpd.description",
                    defaultMessage: "Capture & prioritize ideas"
                }),
                isNew: true
            },
            {
                key: "compass",
                logo: "compass",
                href: "/software/compass",
                name: "Compass",
                description: defineMessage({
                    id: "globalnav.v2.products.compass.description",
                    defaultMessage: "Optimize software health"
                }),
                isNew: true
            },
            {
                key: "guard",
                logo: "guard",
                href: "/software/guard",
                name: "Guard",
                description: defineMessage({
                    id: "globalnav.v2.products.guard.description",
                    defaultMessage: "Org-wide security & control"
                }),
                isNew: true
            },
            {
                key: "loom",
                logo: "loom",
                href: "//loom.com",
                name: "Loom",
                description: defineMessage({
                    id: "globalnav.v2.products.loom.description",
                    defaultMessage: "Quick, async video updates"
                }),
                isNew: true
            }
        ];
    }, []);
}

export const MobileNavProductEveryone = () => {
    const intl = useIntl();

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productseveryone.title",
                defaultMessage: "Products for Everyone"
            })}
            cards={productsData}
        />
    );
};
